import React from 'react';

import SocialShare from '../SocialShare';
import Legal from '../Legal';
import PromoUnitsSmall from '../PromoUnitsSmall';
import ImageCard from '../ImageCard';
import HowToPlay from '../HowToPlay';
import GiveawayMasthead from '../GiveawayMasthead';
import VideoGallery from '../VideoGallery';
import SingleVideo from '../SingleVideo';
import BannerAd from '../BannerAd';
import PromoUnits from '../PromoUnits';
import BonusPuzzle from '../BonusPuzzle';
import GiveawayEntryForm from '../GiveawayEntryForm';
import ImageCarousel from '../ImageCarousel';
import VideoGalleryWide from '../VideoGalleryWide';
import OfficialRules from '../OfficialRules';
import Faqs from '../Faqs';
import GoogleAd from '../GoogleAd';
import FullWidthImageCard from '../FullWidthImageCard';
import Video from '../Video';
import SingleImageSlider from '../SingleImageSlider';
import Ads from '../Ads';
import CountdownCalendar from '../CountdownCalendar';

interface ComposerMapType {
  [key: string]: React.ComponentType<any>;
}

const ComposerMap: ComposerMapType = {
  socialShare: SocialShare,
  legal: Legal,
  promoUnitsSmall: PromoUnitsSmall,
  imageCard: ImageCard,
  howToPlay: HowToPlay,
  giveawayMasthead: GiveawayMasthead,
  videoGallery: VideoGallery,
  adUnit: BannerAd,
  promoUnits: PromoUnits,
  bonusPuzzle: BonusPuzzle,
  giveawayEntryForm: GiveawayEntryForm,
  singleVideo: SingleVideo,
  imageCarousel: ImageCarousel,
  videoGalleryWide: Video,
  headerSlider: SingleImageSlider,
  officialRules: OfficialRules,
  faqs: Faqs,
  googleAds:GoogleAd,
  fullwidth_image_card: FullWidthImageCard,
  ads: Ads,
  countdownCalendar: CountdownCalendar,
};

interface ComposerType {
  componentName: string;
  data: any;
  dyanmodb_table : string;
  BodyBackgroundColor : string;
  bodyBackgroundDesktopImg : string;
  bodyBackgroundMobileImg : string;
  status : string;
}

const Composer: React.FC<ComposerType> = ({ componentName, data,dyanmodb_table ,BodyBackgroundColor, bodyBackgroundDesktopImg, bodyBackgroundMobileImg,status}) => {

  const Component = ComposerMap[componentName];

  return Component ? ( <React.Fragment>{<style dangerouslySetInnerHTML={{
  __html: `body{
    background: ` + BodyBackgroundColor + ` url(` + bodyBackgroundDesktopImg + `);
  }
  @media (max-width: 767px) {
    body{
      background: ` + BodyBackgroundColor + ` url(` + bodyBackgroundMobileImg + `);
    }
  }
`
}} /> } <Component dyanmodb_table = {dyanmodb_table} {...data} /></React.Fragment>) : null;
};

export default Composer;
